/**
 * The one place a date becomes words in this build.
 *
 * It exists because two places disagreed. sharingModel spelled the months out
 * in an array and rendered "4 Sep 2026"; WidestViewPolicy reached for
 * `toLocaleDateString('en-AU', { month: 'short' })` and rendered "4 Sept 2026"
 * on the same screen — en-AU's ICU data abbreviates September to four letters,
 * alone among the twelve. Two spellings of one month on one page is the kind of
 * thing a reader notices and cannot explain, and it was invisible in tests
 * because both were "correct".
 *
 * So the months are written out rather than left to Intl, and everything that
 * prints a date imports from here. Node's ICU build is another reason: en-AU's
 * `month: 'short'` gives "Jun" in a browser and "June" under some Node builds,
 * so a date could render differently in the app and in its own test.
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// A date with no time ("2026-03-12", e.g. a to-do's due date) is read as that
// calendar day. new Date() would take it as UTC midnight and, west of
// Greenwich, show the day before.
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/

function parse(iso: string): Date {
  const m = DATE_ONLY.exec(iso)
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(iso)
}

/** "12 Mar 2026" — the figures' own date form. Null when there is no date. */
export function shortDate(iso: string | null | undefined): string | null {
  if (!iso) return null
  const parsed = parse(iso)
  if (Number.isNaN(parsed.getTime())) return null
  return `${parsed.getDate()} ${MONTHS[parsed.getMonth()]} ${parsed.getFullYear()}`
}

/** "12 Mar" — the shorter form the change feed uses down its left edge. */
export function dayAndMonth(iso: string | null | undefined): string {
  if (!iso) return ''
  const parsed = parse(iso)
  if (Number.isNaN(parsed.getTime())) return ''
  return `${parsed.getDate()} ${MONTHS[parsed.getMonth()]}`
}
